import React from 'react';
import { APP_STORE_URL, GOOGLE_PLAY_URL } from './appStoreUrls';

export { APP_STORE_URL, GOOGLE_PLAY_URL } from './appStoreUrls';

const AppleLogo = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
  </svg>
);

const GooglePlayLogo = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <path fill="#00D2FF" d="M1.5 1.5v21l11.25-10.5L1.5 1.5z" />
    <path fill="#00F076" d="M12.75 12 1.5 22.5c.45.45 1.2.6 1.8.3l14.55-8.4L12.75 12z" />
    <path fill="#FF3A44" d="M18.15 13.8 12.75 12l-5.4 1.8 14.55-8.4c.6-.3 1.35-.15 1.8.3l-5.55 10.2z" />
    <path fill="#FFB900" d="M18.15 10.2 3.3 1.8C2.7 1.5 1.95 1.65 1.5 2.1l11.25 9.9 5.4-1.8z" />
  </svg>
);

const AppStoreLinks = ({
  className = '',
  iconClassName = 'h-7 w-7',
  appleIconClassName = 'text-white',
  variant = 'icons',
  badgeClassName = 'h-10 w-auto',
}) => (
  <div className={`flex items-center gap-3 ${className}`}>
    <a
      href={APP_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Download Rink on the App Store"
      className={
        variant === 'badges'
          ? 'inline-flex transition-transform duration-300 hover:scale-105'
          : `inline-flex items-center justify-center rounded-lg p-1 transition-transform duration-300 hover:scale-110 ${appleIconClassName}`
      }
    >
      {variant === 'badges' ? (
        <img
          src="/images/app-store-badge.svg"
          alt="Download on the App Store"
          className={badgeClassName}
        />
      ) : (
        <AppleLogo className={iconClassName} />
      )}
    </a>
    <a
      href={GOOGLE_PLAY_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Get Rink on Google Play"
      className={
        variant === 'badges'
          ? 'inline-flex transition-transform duration-300 hover:scale-105'
          : 'inline-flex items-center justify-center rounded-lg p-1 transition-transform duration-300 hover:scale-110'
      }
    >
      {variant === 'badges' ? (
        <img
          src="/images/google-play-badge.svg"
          alt="Get it on Google Play"
          className={badgeClassName}
        />
      ) : (
        <GooglePlayLogo className={iconClassName} />
      )}
    </a>
  </div>
);

export default AppStoreLinks;
